import React, {useEffect, useContext} from 'react';

import QueryActions from './QueryActions'
import ResultTable from './ResultTable'
import styles from "./ResultTable.module.scss";
import queryActionsStyles from "./QueryActions.module.scss";
import {UserQuery} from "../../../containers/QueryBuilder/types/UserQuery";
import ResultTableResizeButton from "./ResultTableResizeButton";
import {QueryBuilderContext, QueryBuilderContextType} from "../QueryBuilderContext";
import {Space, Tag} from "antd";
import SaveQueryToggle from "../SaveQueryToggle";
import {InfoCircleOutlined} from "@ant-design/icons";

interface ResultPanelProps {
    isExpanded: boolean
    toggleCollapse: () => void
    queryId: string | undefined;
    userQuery: UserQuery
    setUserQuery: (userQuery: UserQuery) => void
    isCohortAnalyser: boolean
}

const ResultPanel = ({
                         isExpanded,
                         toggleCollapse,
                         queryId,
                         userQuery,
                         setUserQuery,
                         isCohortAnalyser
                     }: ResultPanelProps) => {

    const {queryResult} = useContext(QueryBuilderContext) as QueryBuilderContextType

    useEffect(() => {
        if (isExpanded) {
            window.scrollTo(0, 0)  // Reset scroll to top (Safari bug)
            document.body.style.overflow = 'hidden' // Hide overflow
        } else {
            document.body.style.overflow = '' // Reset overflow
        }

        // minimize the results table when 'Escape' key is pressed
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape' && isExpanded) {
                toggleCollapse()
            }
        };

        window.addEventListener('keydown', handleKeyDown)

        return () => {
            document.body.style.overflow = '' // Cleanup on unmount
            window.removeEventListener('keydown', handleKeyDown)
        }
    }, [isExpanded, toggleCollapse])

    return <>

        <div className={queryActionsStyles.queryActionsGroup}>

            <div className={queryActionsStyles.queryActionsTopGroup}>

                {
                    (queryResult?.valueAvailable)
                        ?

                        <Space size={24} align='center'>

                            {/*Result table resize toggle*/}
                            <ResultTableResizeButton userQuery={userQuery}
                                                     isExpanded={isExpanded}
                                                     toggleCollapse={toggleCollapse}
                                                     isQueryResultAvailable={queryResult?.valueAvailable}
                            />

                            {/*Query Label and Category*/}
                            <Space size={24} align='center'>
                                <SaveQueryToggle queryId={queryId}
                                                 userQuery={userQuery}
                                                 setUserQuery={setUserQuery}
                                                 isQueryResultAvailable={queryResult?.valueAvailable}
                                                 onlyShowSavedQueryEditButton={true}
                                />
                            </Space>

                        </Space>
                        :
                        null
                }

            </div>

            <div className={queryActionsStyles.queryActionsBottomGroup}>

                {/*NHS data suppression disclaimer*/}
                <Tag className={queryActionsStyles.dataSuppressionNotice}
                     icon={<InfoCircleOutlined/>}>
                    Small number suppression has been applied to all outputs, in accordance with NHS England guidelines.
                </Tag>

                {/*Query actions*/}
                <QueryActions/>

            </div>

        </div>

        <div className={`${styles.result_container} ${isExpanded ? styles.result_container_expanded : ''}`}>
            <ResultTable isCollapsed={isExpanded} isCohortAnalyser={isCohortAnalyser}/>
        </div>

    </>

}

export default ResultPanel